import FileUpload from "components/FileUpload";
import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import {
  addCaseRespondBackComment,
  editCaseCreation,
} from "services/caseServices";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  caseId: number;
  onClose: (refetch: boolean) => void;
};

const RespondBackComment: FC<Props> = ({ caseId, onClose }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState<string>("");
  const [feedbackFile, FeedbackFile] = useState<File | null>(null);

  const validateForm = () => {
    if (!comment.trim()) return "Comment is Required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);
    const data = {
      role: "coordinator",
      feedback_files: feedbackFile,
      status: "respond_back",
      comment: comment,
      case: caseId,
    };

    addCaseRespondBackComment(data)
      .then(() => {
        editCaseCreation({
          id: caseId,
          status: "Respond_Back_prosecutor",
        });
        showTooltip("Successfully Updated!", "success");
        onClose(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl border border-gray-200">
        <div className="p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">
            Respond Back to Prosecutor
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Provide feedback and upload supporting documents
          </p>
        </div>

        <form className="p-6 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Feedback Comment <span className="text-red-600">*</span>
            </label>
            <textarea
              rows={4}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your feedback here..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Feedback File (optional)
            </label>
            <FileUpload
              label="Upload feedback document"
              fileTypes="*"
              required={false}
              onChange={(file) => FeedbackFile(file)}
            />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              className="px-6 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Processing...
                </div>
              ) : (
                "Submit Feedback"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RespondBackComment;
